import * as React from 'react';

export const lockedIcon = (
  <svg
    width="17"
    height="22"
    viewBox="0 0 17 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.0086 21.9999H3.96463C1.77885 21.9999 -0.000488281 20.2337 -0.000488281 18.0629V12.2472C-0.000488281 10.5501 1.07206 9.07511 2.65306 8.5292V5.73981C2.65306 2.83939 5.02945 0.479248 7.94984 0.479248H9.02342C11.9443 0.479248 14.3207 2.83939 14.3207 5.73981V8.52971C15.9017 9.07511 16.9738 10.5501 16.9738 12.2472V18.0629C16.9738 20.2337 15.1949 21.9999 13.0086 21.9999ZM11.4356 9.00001H5.56372C5.25252 9.00001 4.99992 8.78059 4.99992 8.50917V5.53096C4.99992 4.13522 6.30389 3.00001 7.90654 3.00001H9.09217C10.6948 3.00001 11.9999 4.13522 11.9999 5.53096V8.50917C11.9999 8.78059 11.7468 9.00001 11.4356 9.00001ZM6.99992 15.6848C6.99992 16.4101 7.67278 17 8.49992 17C9.32707 17 9.99992 16.4101 9.99992 15.6848V14.3147C9.99992 13.5895 9.32707 13 8.49992 13C7.67278 13 6.99992 13.5895 6.99992 14.3147V15.6848Z"
        fill="#292F2F"
      />
    </g>
  </svg>
);
